import React from 'react';

import {
  headlineClass,
  tableCellClass,
  tableCellFullClass,
} from '~/components/ClaimPage/ClaimPageBar/ClaimPageBarUtils';
import cn from '~/Utils/cn';

import DividerCell from './DividerCell';

type GenericClaimBarFieldProps = {
  title?: React.ReactNode;
  allowWrapping?: boolean;
  content?: React.ReactNode;
  children?: React.ReactNode;
  hideDivider?: boolean;
};

const GenericClaimBarField = ({
  title = null,
  allowWrapping = true,
  content = null,
  children = null,
  hideDivider = false,
}: GenericClaimBarFieldProps) => {
  const hasContent = content || content === 0;

  return (
    <>
      {hideDivider ? null : <DividerCell />}
      {/* A subgrid of the bar's headline and value tracks, so every cell's headline and value share
          the same two rows whatever the value renders as. */}
      <div className={cn('row-span-2 grid grid-rows-subgrid', allowWrapping ? tableCellClass : tableCellFullClass)}>
        {title ? <div className={headlineClass}>{title}</div> : null}
        {hasContent || children ? (
          <div className="self-center">
            {hasContent ? content : null}
            {children}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default GenericClaimBarField;
